import PropTypes from 'prop-types';

import { itemsWorkReport } from '../../../../utils/globalPropTypes';
import { AttachedFilesPermissions } from '../../../MonthlyServiceRequest/RequestDetailTypes';

import DailyWorkReportApproval from './DailyWorkReportApproval/DailyWorkReportApproval';

const HeaderTableApprovalPending = (props) => {
  const {
    fetchData,
    workReportsSecondLevel,
    selectedDate,
    selectedInput,
    showApproveButton,
    showEditButton,
    showRejectButton,
    permissions,
    showPPButton
  } = props;

  return (
    <>
      {workReportsSecondLevel && workReportsSecondLevel.length
        ? workReportsSecondLevel.map(
            ({ items: serviceLevel, agrupadoPor: providerOrUbication }) => (
              <>
                {serviceLevel.map(({ items: contractLevel, agrupadoPor: service }, index) => (
                  <DailyWorkReportApproval
                    contractLevel={contractLevel}
                    fetchData={fetchData}
                    key={`${Date.now()}${index.toString()}`}
                    permissions={permissions}
                    providerOrUbication={providerOrUbication}
                    selectedDate={selectedDate}
                    selectedInput={selectedInput}
                    service={service}
                    showApproveButton={showApproveButton}
                    showEditButton={showEditButton}
                    showPPButton={showPPButton}
                    showRejectButton={showRejectButton}
                  />
                ))}
              </>
            )
          )
        : null}
    </>
  );
};

export default HeaderTableApprovalPending;

HeaderTableApprovalPending.propTypes = {
  fetchData: PropTypes.func.isRequired,
  workReportsSecondLevel: itemsWorkReport.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedInput: PropTypes.string.isRequired,
  showApproveButton: PropTypes.bool.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  showRejectButton: PropTypes.bool.isRequired,
  permissions: AttachedFilesPermissions,
  showPPButton: PropTypes.bool.isRequired
};

HeaderTableApprovalPending.defaultProps = {
  permissions: {
    visualize: false,
    write: false
  }
};
